export default {
  namespaced: true,

  state: {           
        productOptions: [
            {id: 'SD', name: 'Simcenter E-Machine Design'},
            {id: 'archived', name: 'Archived'}
        ]
  },
  getters: {},
  mutations: {},
  actions: {}
}

